import { render, staticRenderFns } from "./code-of-conduct-dialog.vue?vue&type=template&id=46b31eb1&scoped=true&"
import script from "./code-of-conduct-dialog.vue?vue&type=script&lang=js&"
export * from "./code-of-conduct-dialog.vue?vue&type=script&lang=js&"
import style0 from "./code-of-conduct-dialog.vue?vue&type=style&index=0&id=46b31eb1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b31eb1",
  null
  
)

export default component.exports